<template>
    <div class="helpBox privacy" id="agreementBox">
        <h1 style="padding-bottom: 20px;"><img src="//img.fenfenriji.com//ED/56/AF/Image/8D375573-52CB-0841-577F-5AB1C59342DD.png" alt="" style="display: block;width: 300px;margin: 0 auto ;"></h1>
        <p style="padding-top: 30px">1、进入<span style="font-weight: bold;">App Store</span>，拖到页面最底部。选择“绑定支付宝”或“绑定银联卡支付”，选其一即可。</p>
        <img class="img" src="http://app.mall.fenfenriji.com/vip201703/static/img/1.png" alt="">
        <p>2、输入Apple ID登录密码。</p>
        <img class="img" src="http://app.mall.fenfenriji.com/vip201703/static/img/2.png" alt="">
        <p>3、完成相关信息的填写，进行确认</p>
        <img class="img" src="http://app.mall.fenfenriji.com/vip201703/static/img/3.png" alt="">
        <p>4、返回到“粉粉日记”内，点击“我的”-“会员中心”进行充值。</p>
        <div style="height:40px"></div>
    </div>
</template>
<script>
    export default {

    }
</script>



// WEBPACK FOOTER //
// src/components/agreement/agreement2.vue